import { Box, Paper, useTheme } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { GoPlus } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';


import {  useListArtsByCustomer } from './arts-list.hook';
import { DestroyArtsUseCase } from '../../../Usecase/Arts/destroy-arts-usecase';
import { ListArtsUseCase } from '../../../Usecase/Arts/list-arts-usecase';
import { ListCustomersUseCase } from '../../../Usecase/Customers/list-customers-usecase';
import { ButtonActionMenu } from '../../../Components/Form/ButtonActionsMenu/button-action-menu.component';
import { ListArtsByCustomerUseCase } from '../../../Usecase/Arts/list-by-cusomter-usecase';
import { ShowCustomersUseCase } from '../../../Usecase/Customers/show-customers-usecase';
import { PDFPreview } from '../../../Components/PDFPreview/pdf-preview.component';

interface IArtListByCustomer {
  listArtsUseCase: ListArtsUseCase
  destroyArtsUseCase: DestroyArtsUseCase
  listCustomersUseCase: ListCustomersUseCase
  listArtsByCustomerUseCase: ListArtsByCustomerUseCase
  showCustomersUseCase: ShowCustomersUseCase
}
const ArtListByCustomer : FC<IArtListByCustomer> = ({ listArtsUseCase, destroyArtsUseCase, listCustomersUseCase, listArtsByCustomerUseCase, showCustomersUseCase }) => {
    const theme = useTheme()


    const {  list, setArtToDestroy, artToDestroy, handleDestroyArt, totalRegistersCustomer, loadArts, navigate, customerSelected } = useListArtsByCustomer({
      listArtsUseCase,
      destroyArtsUseCase,
      listCustomersUseCase,
      listArtsByCustomerUseCase,
      showCustomersUseCase
    })


    useEffect(() => {
        // listArts({ page: 1})
        loadArts({ page: 1})
    }, [])


    const columns = useMemo(() => {
        const createColumns: any[] = [
          {
            field: 'photo',
            headerName: 'Imagem',
            // renderCell: (params: any) => <Box component='img' src={params.value} sx={{ width: '80px', height: '80px', objectFit: 'contain'}} />
            renderCell: (params: any) => <PDFPreview dropboxLink={params.value} />

            
          },
        
          {
            field: 'name',
            headerName: 'Produto',
            flex: 1
          },
          {
            field: "actions",
            headerName: "Ações",
            
            renderCell: (params: any) => <ActionButtons params={params} setItemToDestroy={setArtToDestroy} editLink={`/arts-form/${params.row.id}`} />
            //  renderCell: (params: any) => <ButtonActionMenu options={[
            //   {
            //     title: 'Acessar',
            //     onClick: () => navigate(`/arts-customer-details/${params.row.id}`),
            //   }
            // ]} />
          }
        ];
      
        return createColumns;
      }, []);
   

    return (
        <BaseScreen>
        <ConfirmDialog title='Remover Arte' onCancel={() => setArtToDestroy('')} description='Você tem certeza?' open={!!artToDestroy} onConfirm={handleDestroyArt}  /> 
            <Paper >
                <BaseContentPage 
                    title='Artes'
                    search
                    searchFunction={loadArts}
                    placeholderSearch='Pesquise pelo nome do Produto'
                    breadcrumb={[{ title: 'Artes', link: "/arts-list"}, { title: 'Listagem'}, { title: customerSelected?.name || ''}]}
                    breadcrumbStyle={{ marginTop: '20px'}}
                    Action={() => <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '130px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate(`/arts-form?customerId=${customerSelected?.id}`)}>Adicionar</Button>}
                >
                  {!!list?.length ? <Table data={list} isRowSelectable={() => false}  totalCount={totalRegistersCustomer} columns={columns} onPageChange={loadArts}  /> : <Placeholder description='Nenhum dado encontrado.' />}
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
    )
}

export { ArtListByCustomer };
